import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useStudentWorkspace } from '../../contexts/LmsDataContext';
import {
  FaBookOpen,
  FaCalendarAlt,
  FaCreditCard,
  FaHome,
  FaUser,
  FaUsers,
  FaGraduationCap,
  FaClipboardList,
} from 'react-icons/fa';

const navByRole = {
  student: [
    { to: '/dashboard', label: 'Home', icon: FaHome },
    { to: '/courses/available', label: 'Courses', icon: FaGraduationCap },
    { to: '/schedule', label: 'Schedule', icon: FaCalendarAlt },
    { to: '/payments', label: 'Payments', icon: FaCreditCard },
    { to: '/profile', label: 'Profile', icon: FaUser },
  ],
  instructor: [
    { to: '/dashboard', label: 'Home', icon: FaHome },
    { to: '/courses/available', label: 'Courses', icon: FaBookOpen },
    { to: '/students', label: 'Students', icon: FaUsers },
    { to: '/schedule', label: 'Schedule', icon: FaCalendarAlt },
    { to: '/profile', label: 'Profile', icon: FaUser },
  ],
  admin: [
    { to: '/dashboard', label: 'Home', icon: FaHome },
    { to: '/courses/available', label: 'Courses', icon: FaBookOpen },
    { to: '/students', label: 'Students', icon: FaUsers },
    { to: '/payments', label: 'Payments', icon: FaCreditCard },
    { to: '/profile', label: 'Profile', icon: FaUser },
  ],
  staff: [
    { to: '/dashboard', label: 'Home', icon: FaHome },
    { to: '/reception/kiosk', label: 'Kiosk', icon: FaClipboardList },
    { to: '/schedule', label: 'Schedule', icon: FaCalendarAlt },
    { to: '/payments', label: 'Payments', icon: FaCreditCard },
    { to: '/profile', label: 'Profile', icon: FaUser },
  ],
};

const MobileBottomNav = () => {
  const { currentUser } = useAuth();
  const { data: studentCourseData } = useStudentWorkspace();
  const hasActiveStudentCourse =
    currentUser?.role === 'student' &&
    Boolean(studentCourseData?.activeCourses?.length);
  const items =
    currentUser?.role === 'student'
      ? navByRole.student.map((item) =>
          item.to === '/courses/available' && hasActiveStudentCourse
            ? { ...item, to: '/courses/my-courses', label: 'My courses', icon: FaBookOpen }
            : item,
        )
      : navByRole[currentUser?.role] || navByRole.student;

  return (
    <nav className="fixed inset-x-0 bottom-0 z-20 border-t border-stone-200 bg-white/95 px-2 pb-[calc(env(safe-area-inset-bottom,0px)+0.55rem)] pt-2 shadow-[0_-18px_36px_-28px_rgba(28,25,23,0.28)] backdrop-blur md:hidden">
      <div className="mx-auto grid max-w-xl grid-cols-5 gap-1">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex min-h-[58px] flex-col items-center justify-center gap-1 rounded-2xl px-1 transition ${
                  isActive
                    ? 'bg-[#fdf2f8] text-[#b91c66]'
                    : 'text-stone-500 hover:bg-stone-50 hover:text-stone-800'
                }`
              }
            >
              <Icon className="h-4 w-4" />
              <span className="text-[11px] font-semibold">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
